import React from 'react'
import classes from "./styles.module.scss";

export interface StatisticsProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  description: string;
}

const Statistics: React.FC<StatisticsProps> = ({ value, description}) => {
  return (
    <div className={classes.Statistics}>
      <div className={classes.value}>{value}</div>
      <div className={classes.description}>{description}</div>
    </div>
  )
}

export default Statistics